<script setup lang="ts">
  import { onMounted, PropType, ref, watch } from 'vue'

  import { Modal } from 'bootstrap'

  const MODAL_ID = 'modal-email-ownership-blocked'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const props = defineProps({
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: false,
      default: () => void 0,
    },
  })

  onMounted(() => {
    modal.value = new Modal(`#${MODAL_ID}`, {
      backdrop: 'static',
      keyboard: false,
    })
  })

  watch(
    () => props.show,
    (newValue) => {
      if (newValue) {
        modal.value?.show()
        return
      }

      forceHide()
    },
  )

  function forceHide() {
    modal.value?.hide()
    document
      .querySelectorAll('.modal-backdrop')
      .forEach((backdrop) => backdrop.remove())
    document.getElementById(MODAL_ID)?.classList.remove('show')
    document.body.classList.remove('modal-open')
  }

  function hide() {
    modal.value?.hide()
    setTimeout(() => {
      props.onClose?.()
    }, 300)
  }
</script>

<template>
  <div
    :id="MODAL_ID"
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalEmailOwnershipBlockedTitle"
  >
    <div class="modal-dialog text-start">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div class="d-flex justify-content-center mb-3">
            <img
              class="illustration"
              src="@/assets/images/worried-girl.svg"
              alt="Ilustração de e-mail vinculado a outro CPF"
            />
          </div>
          <h1
            id="modalEmailOwnershipBlockedTitle"
            class="fs-5 fw-600 text-center"
          >
            Este e-mail já está vinculado a outro CPF
          </h1>
          <p class="text-center">
            Para continuar, informe um e-mail diferente. Assim conseguiremos
            confirmar sua titularidade.
          </p>
          <div class="alert alert-danger d-flex" role="alert">
            <span>
              O e-mail informado já está vinculado a outro CPF. Por favor,
              informe um e-mail diferente.
            </span>
          </div>
        </div>
        <div class="modal-footer flex-column border-top-0 pt-0">
          <button class="btn btn-primary w-100" type="button" @click="hide">
            <span>Entendi</span>
          </button>
          <p class="text-muted small mt-2 mb-0 text-center">
            Você poderá informar um novo e-mail e tentar novamente
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .illustration
    height: 160px

  .modal-dialog
    max-width: 420px

  @media screen and (max-width: 576px)
    .modal-dialog
      height: auto
      margin: 0.5rem
    .modal-content
      border-radius: 0.5rem
</style>
